import React from 'react';
import Toggle from '../Toggle/Toggle';
import FormattedInput from '../FormattedInput/FormattedInput';
import styles from './ForcedTipSection.module.scss';

export interface ForcedTipSectionProps {
  /** Whether forced tip is enabled */
  enabled: boolean;
  /** Callback when forced tip toggle changes */
  onEnabledChange: (enabled: boolean) => void;
  /** The forced tip percentage value */
  percentage: number;
  /** Callback when percentage changes */
  onPercentageChange: (percentage: number) => void;
  /** Loading state */
  loading?: boolean;
  /** Additional CSS classes */
  className?: string;
  /** Placeholder text for the percentage input */
  placeholder?: string;
}

const ForcedTipSection: React.FC<ForcedTipSectionProps> = ({
  enabled,
  onEnabledChange,
  percentage,
  onPercentageChange,
  loading = false,
  className = '',
  placeholder = '0',
}) => {
  const handlePercentageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(event.target.value) || 0;
    onPercentageChange(value);
  };

  return (
    <div className={`${styles.forcedTipSection} ${className}`}>
      <div className={styles.toggleContainer}>
        <Toggle
          checked={enabled}
          onChange={onEnabledChange}
          loading={loading}
          additionalStyles={styles.leftAlignedToggle}
        />
      </div>
      <div className={styles.percentageContainer}>
        <FormattedInput
          format="percentage"
          value={percentage}
          onChange={handlePercentageChange}
          placeholder={placeholder}
          disabled={!enabled}
          loading={loading}
        />
      </div>
    </div>
  );
};

export default ForcedTipSection;
